import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import Chart from "react-apexcharts";
import Config from "../Config";
import { useAuthHandling } from "../useAuthhandling";
function Blogpie() {
  //   const [options, setOptions] = useState({
  //     labels: ["Previous week", "This week"],
  //   });

  const [blogs, setBlogs] = useState([]);
  const [professionals, setProfessionals] = useState([]);

  const { isAuthorized, handleUnauthorized } = useAuthHandling();


  const getinfo = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/dashboard/blog-statics`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200) {
      const data = await res.json();
      setBlogs(data.data[0]);
    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };

 
  useEffect(() => {
    getinfo();
  }, []);

  var options = {
    colors: ["#cc0099", "#9900cc"],

    labels: ["Previous week", "This week"],
    fill: {
      colors: ["#cc0099", "#9900cc"],
    },
    stroke: {
      colors: ["#cc0099", "#9900cc"],
    },
    markers: {
      colors: ["#cc0099", "#9900cc"],
    },
    title: {
      text: "No of blogs previous week vs this week",
      align: "left",
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize: "14px",
        fontWeight: "400",
        fontFamily: undefined,
        color: "#fff",
        marginTop: "12px",
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };
  return (
    <div className="blogpie">
      <Chart
        options={options}
        type="pie"
        series={[blogs?.currentWeekCount, blogs?.previousWeekCount]}
        color="white"
        height="300px"
      />
    </div>
  );
}

export default Blogpie;
